import classNames from 'classnames';

import { useIsMobile } from '@sravni/react-utils';

import styles from './styles.module.scss';

interface LayoutProps extends Omit<React.AllHTMLAttributes<HTMLElement>, 'as' | 'type' | 'crossOrigin'> {
  as?: keyof React.ReactHTML | React.ComponentType;
}

export const Layout = ({ as: Component = 'div', className, ...props }: LayoutProps) => {
  const isMobile = useIsMobile();

  return <Component className={classNames(className, styles.layout, isMobile && styles.mobile)} {...props} />;
};
